import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=476ff050&scoped=true&"
import script from "./forgot.vue?vue&type=script&lang=ts&"
export * from "./forgot.vue?vue&type=script&lang=ts&"
import style0 from "./forgot.vue?vue&type=style&index=0&id=476ff050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ff050",
  null
  
)

export default component.exports